import React, { Component } from 'react';
import PropTypes from 'prop-types';

import StaffList from './ActForm/StaffList';
import GiveDeductList from './ActForm/GiveDeductList';
import StepThreeGroup from './ActForm/StepThreeGroup';

import { Commons } from 'components';

const propTypes = {};

const defaultProps = {};

class ActForm extends Component {
  constructor(props) {
    super(props);
  }

  continueBtn = () => {
    const { data } = this.props;
    let type = data.topMenu.tabType;
    location.href = '/main/sikdaeGiveDeduct?type=' + type;
  };

  checkBtn = () => {
    this.context.router.history.push('/main/sikdaeGivenList');
  };

  render() {
    const { fn, data } = this.props;

    const giveDeductProps = {
      fn: {
        stepTwoSikdaeGroupClick: fn.stepTwoSikdaeGroupClick,
        selectBoxhandleChange: fn.selectBoxhandleChange,
        allBtn: fn.allBtn
      },
      data: {
        groupNum: data.groupNum,
        staffCheckedData: data.staffCheckedData
      }
    };

    const StepThreeGroupProps = {
      data: {
        groupNum: data.groupNum,
        staffCheckedData: data.staffCheckedData,
        dataSet: data.dataSet,
        topMenu: data.topMenu
      },
      fn: {
        stepThreeAllBtn: fn.stepThreeAllBtn,
        tabTotalData: fn.tabTotalData
      }
    };

    const staffListProps = {
      data: {
        param: data.param,
        staffCheckedData: data.staffCheckedData,
        isChecked: data.isChecked
      }
    };

    return (
      <div>
        {data.topMenu.nowStep === 'step1' ? (
          <StaffList
            staffSel={fn.staffSel}
            staffChecked={fn.staffChecked}
            isChecked={data.isChecked}
            staffCheckedData={data.staffCheckedData}
            params={data.param}
          />
        ) : null}
        {data.topMenu.nowStep === 'step2' ? (
          <GiveDeductList data={giveDeductProps.data} fn={giveDeductProps.fn} />
        ) : null}
        {data.topMenu.nowStep === 'step3' ? (
          <StepThreeGroup data={StepThreeGroupProps.data} auth={data.auth} fn={fn} />
        ) : null}
        {data.topMenu.nowStep === 'step4' ? (
          <Commons.ResultPage success continueBtn={this.continueBtn} checkBtn={this.checkBtn} />
        ) : null}
      </div>
    );
  }
}

ActForm.propTypes = propTypes;
ActForm.defaultProps = defaultProps;

ActForm.contextTypes = {
  router: PropTypes.object.isRequired
};

export default ActForm;
